import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import formatPrice from '../../../helpers/formatPrice';
import 'react-loading-skeleton/dist/skeleton.css';

function Flex() {
  const reduxState = useSelector((state) => state);
  const payments = useSelector((state) => state.payments);

  const { totalDiscountPercentage, poupancinha, iepayment } = payments;

  const { pathname } = window.location;
  const paths = pathname.split('/');
  const linktype = paths[3];
  const { quote: { destinyCountry } } = reduxState;

  const skeletonLoading = () => (
    <>
      <Skeleton width="50%" />
      <Skeleton height="25px" />
      <Skeleton style={{ marginLeft: '50%' }} count={3} height="30px" width="50%" />
      <Skeleton width="50%" />
    </>
  );

  return (
    <td className="d-block">
      {
        poupancinha.length === 0
          ? skeletonLoading()
          : (
            <>
              {
                totalDiscountPercentage > 0
                && (
                  <div className={(iepayment.poupancinhaDPType === 1) ? 'd-flex justify-content-between align-items-center' : 'mt-3 d-flex justify-content-between align-items-center'}>
                    <p className="blue mt-1">
                      Entrada fácil:
                    </p>
                    {iepayment.poupancinhaDPType === 1 && (
                      <p className="mt-1">
                        {'de '}
                        <span
                          className="text-decoration-line-through text-danger"
                        >
                          {`${formatPrice(poupancinha[0].totalAmountWithoutSR)}`}
                        </span>
                        {' por:'}
                      </p>
                    )}
                    {iepayment.poupancinhaDPType === 2 && (
                      <p style={{ lineHeight: '21px', marginTop: '-3px' }} className="blue strong fs-large text-align-end mb-0">
                        {formatPrice(poupancinha[0].totalAmount)}
                        <span className="small"> (à vista)</span>
                      </p>
                    )}
                  </div>
                )
              }
              <div className={!(totalDiscountPercentage > 0) && 'd-flex justify-content-between align-items-center'}>
                {!(totalDiscountPercentage > 0) && (
                  <p className={`blue ${totalDiscountPercentage > 0 ? 'mt-1' : 'mt-3'}`}>
                    Entrada fácil:
                  </p>
                )}
                {iepayment.poupancinhaDPType === 1 && (
                  <p style={{ lineHeight: '20px' }} className="blue strong fs-large text-align-end mt-2 mb-0">
                    {formatPrice(poupancinha[0].totalAmount)}
                    <span className="small"> (à vista)</span>
                  </p>
                )}
              </div>
              {/* {
                poupancinha.map(({ quantity, installmentAmount }, index) => (
                  <p key={installmentAmount} className="my-0 text-align-end">
                    <span className="text-muted">{`${quantity}x no cartão de`}</span>
                    <span className="strong">{` ${formatPrice(installmentAmount)} `}</span>
                    {index !== poupancinha.length - 1 && <span className="text-muted">ou</span>}
                  </p>
                ))
              } */}

              {(linktype !== '2') && (
              <p className="text-align-end">
                {formatPrice(poupancinha[0].entryDestinyCurrency, poupancinha[0].currency)}
              </p>
              )}
              <p
                style={{ borderTop: '1px solid gray' }}
                className="d-flex justify-content-between align-items-center mt-2 pt-2"
              >
                {(linktype !== '3') && (
                <>
                  <span>{'Saldo: '}</span>
                  <span>
                    {formatPrice(poupancinha[0].remainingValue, poupancinha[0].currency)}
                  </span>
                </>
                )}
                {/* {(linktype === '2') && (
                <>
                  <span>{'Saldo: '}</span>
                  <span>
                    {formatPrice(poupancinha[0].remainingValueBRL, 'BRL')}
                  </span>
                </>
                )} */}
              </p>
            </>
          )
      }

      {(destinyCountry === 'AU' || destinyCountry === 'NZ') && (
        <p className="my-0 small">
          *quitar saldo em até 90 dias antes da data de embarque
        </p>
      )}
      {(destinyCountry !== 'AU' && destinyCountry !== 'NZ') && (
        <p className="my-0 small">
          *quitar saldo em até 45 dias antes da data de embarque
        </p>
      )}
      {(linktype === '2') && (
        <p className="my-0 small">*o saldo poderá ser reajustado no momento da quitação</p>
      )}
    </td>
  );
}

export default Flex;
